<template>
  <section class="p-1" aria-labelledby="payment-methods-title" role="region">
    <h2 id="payment-method-selection-title" class="sr-only">
      {{ $t('paymentMethods.label.selectMethod') }}
    </h2>

    <div class="def-radio">
      <RadioButton
        :label="label"
        :options="radioOptions"
        :value="selectedValue"
        :error="errorMessage"
        :required="true"
        @input="onRadioInput"
        :id="'payment-methods-radio'"
        :icon="icon"
        :iconColor="iconColor"
      />
    </div>
  </section>
</template>

<script>
import RadioButton from '@/components/actions/RadioButton.vue';

export default {
  components: {
    RadioButton
  },
  props: {
    paymenMethods: {
      type: Array,
      default: () => []
    },
    existingBalance: {
      type: Number,
      default: 0
    },
    totalPrice: {
      type: Number,
      default: 0
    },
    label: { type: String, required: true },
    icon: { type: String, default: null },
    iconColor: { type: String, default: null },
  },
  data() {
    return {
      errorMessage: null,
      selectedValue: null,
    };
  },
  computed: {
    isNotEnoughBalance() {
      return this.existingBalance < this.totalPrice;
    },
    radioOptions() {
      return this.paymenMethods.map(method => {
        let label = this.getPaymentLabel(method);
        if (method.paymentType === 5 && this.isNotEnoughBalance) {
          label += ` (${this.$t('paymentMethods.messages.error.noBalance')})`;
        }
        return {
          value: method.code,
          label: label,
          icon: method.icon,
          disabled: this.isMethodDisabled(method),
          method: method // keep reference for selection
        };
      });
    }
  },
  methods: {
    getPaymentLabel(method) {
      switch (method.paymentType) {
        case 4:
          return this.$t('paymentMethods.label.creditCard');
        case 50:
          return this.$t('paymentMethods.label.purchaseOnAccount');
        case 7:
          return this.$t('paymentMethods.label.free');
        case 5:
          return this.$t('paymentMethods.label.customerCard');
        case 1:
          return this.$t('paymentMethods.label.cashOnDelivery');
        default:
          return method.description || method.code;
      }
    },
    onRadioInput(val) {
      this.errorMessage = null;
      this.selectedValue = val;
      // Find the method by code
      const method = this.paymenMethods.find(m => m.code === val);
      if (method) {
        this.$emit('select', method);
      } else {
        this.errorMessage = this.$t('paymentMethods.messages.error.onSelect');
      }
    },
    close() {
      this.$emit('close');
    },
    handlePaymentMethodsError(error) {
      this.errorMessage = error || this.$t('paymentMethods.messages.error.onSelect');
    },
    isMethodDisabled(method) {
      if (method.paymentType === 5 && this.isNotEnoughBalance) return true;
      return !!this.errorMessage;
    },
  },
  mounted() {
    this.$root.$on('payment-methods-error', this.handlePaymentMethodsError);
  },
  beforeDestroy() {
    this.$root.$off('payment-methods-error', this.handlePaymentMethodsError);
  },
};
</script>

<style scoped lang="scss">
@import '@/css/customizer';
</style>
